import TEMPLATE_URL from "emun.auth/permissions/permission-list-prompt.htm";
import controller from "emun.auth/permissions/permission-list-prompt.controller";
import open from "webmodals/open";

const NOOP = () => {};

export default ({
  size = "md",
  backdrop = "static",
  templateUrl = TEMPLATE_URL,
  request: { id, label, description, permissions = [] } = {},
  action = id ? "Update" : "Create",
  title = `${action} Permission List...`,
  view = "cards",
  onToggle = NOOP,
  onPermissionSelected = NOOP,
  onPermissionDeselected = NOOP
} = {}) =>
  open({
    size,
    backdrop,
    templateUrl,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => ({
        title,
        onPermissionSelected,
        onPermissionDeselected,
        view,
        request: {
          id,
          label,
          description,
          permissions: [...permissions]
        }
      })
    }
  }).result;
